var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconIg = function SvgIconIg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.91 23.76c-4.554 0-8.26-3.705-8.26-8.259 0-2.245.923-4.43 2.532-5.994 1.569-1.522 3.618-2.328 5.769-2.265 2.57.077 4.704.942 6.17 2.507 1.39 1.483 2.098 3.483 2.047 5.782a8.457 8.457 0 01-2.445 5.805 8.125 8.125 0 01-5.813 2.424m-.19-13.737c-1.338 0-2.61.522-3.599 1.482a5.606 5.606 0 00-1.687 3.996 5.482 5.482 0 005.476 5.476c3.002 0 5.409-2.42 5.476-5.507.035-1.556-.414-2.877-1.295-3.818-.949-1.012-2.408-1.575-4.22-1.628l-.152-.001M26.295 7.009a1.925 1.925 0 11-3.853 0 1.926 1.926 0 113.853 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.155 31.089H9.665c-4.897 0-8.881-3.985-8.881-8.881V8.88C.784 3.983 4.768 0 9.664 0h12.49c4.897 0 8.882 3.983 8.882 8.88v13.328c0 4.896-3.985 8.88-8.881 8.88zM9.665 2.277A6.61 6.61 0 003.062 8.88v13.327a6.61 6.61 0 006.603 6.604h12.49a6.61 6.61 0 006.603-6.604V8.88a6.61 6.61 0 00-6.603-6.604H9.665z"
  }))));
};

export default SvgIconIg;